<div class="ag-name-value ag-status-link">
    <span (click)="viewFullscreen()">View Fullscreen Grid</span>
</div>